import { useCallback, useEffect, useMemo, useState } from 'react';

import { MarkerTypeApi } from '@/api/api.marker.types';
import { IMarkerType } from '@/models';

export const useMarkerTypes = () => {
  const [markerTypes, setMarkerTypes] = useState<IMarkerType[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchMarkerTypes = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await MarkerTypeApi.getMarkerTypes({
        page: 1,
        limit: 100,
        sort: 'sortOrder',
      });
      setMarkerTypes(response.data.results || []);
      setError(null);
    } catch (err) {
      setError(err as Error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMarkerTypes();
  }, [fetchMarkerTypes]);

  const enabledMarkerTypes = useMemo(
    () => markerTypes.filter((type) => type.isEnabled),
    [markerTypes],
  );

  return {
    markerTypes,
    enabledMarkerTypes,
    isLoading,
    error,
    updateMarkerTypes: fetchMarkerTypes,
  };
};
